import { ChangeDetectorRef, Component, ElementRef, HostListener, OnDestroy, OnInit, Renderer2, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HubConnection, HubConnectionBuilder } from '@microsoft/signalr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Console } from 'console';
import { interval, of, Subscription } from 'rxjs';
import { delay } from 'rxjs/operators';
import { CameraTestModalComponent } from 'src/app/events/live/camera-test/camera-test-modal.component';
import { DefaultReconnectPolicy } from 'src/app/_helpers/signalR-retry-policy';
import { ConferenceRoomViewModel, StreamBoxLayoutViewModel, WowzaChannelViewModel, WowzaState } from 'src/app/_models/generatedModels';
import { SelectedDevice } from 'src/app/_models/models';
import { AnalyticsService } from 'src/app/_services/analytics.service';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { StreamBoxService, SuperUserService } from 'src/app/_services/generatedServices';
import { OpentokService } from 'src/app/_services/opentok.service';
import { ToasterService } from 'src/app/_services/toaster.service';
import { Enums, StrWowzaStateEnum } from "../../_models/generatedEnums";
import Enumerable from "linq";

declare var zE: any;
const initLayoutContainer = require('opentok-layout-js');


@Component({
  selector: 'bxl-stream-box',
  templateUrl: 'stream-box.component.html',
})
export class StreamBoxComponent implements OnInit, OnDestroy {
  initialized = false;
  public selectedCameraDevice: SelectedDevice;
  public selectedScreenDevice: SelectedDevice;
  public connection: HubConnection;
  screenPublisher: OT.Publisher;
  cameraPublisher: OT.Publisher;
  public isFullScreen: boolean;
  @ViewChild('videoCanvas') videoCanvas: ElementRef;
  @ViewChild('background') background: ElementRef;
  @ViewChild('fullscreenContainer') fullscreenContainer: ElementRef;
  session: OT.Session;
  @ViewChild('soundBar', {static: false}) soundBar: ElementRef;
  streamCount: any;
  screenPublishing: boolean;
  cameraPublishing: boolean;
  model: StreamBoxLayoutViewModel;
  streamBoxId: number;
  layout: any;
  openTokInitialized: boolean;
  private checker: Subscription;
  rooms: ConferenceRoomViewModel[];
   selectedRoom: number;

  constructor(private streamBoxService: StreamBoxService, private toasterService: ToasterService, private superUser: SuperUserService, private titleService: AnalyticsService, private auth: AuthenticationService, private route: ActivatedRoute, private modalService: NgbModal, private renderer: Renderer2, private opentokService: OpentokService, private ref: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.route.paramMap.subscribe((params) => {
      this.route.queryParamMap.subscribe((qParams) => {
        this.selectedCameraDevice = JSON.parse(localStorage.getItem('cameraDevice'));
        this.selectedScreenDevice = JSON.parse(localStorage.getItem('screenDevice'));
        this.getData();
        this.checker = interval(10000).subscribe((val) => this.getData());
        this.streamBoxService.getRoomsForConferences().subscribe((result) => {
          this.rooms = result;
          this.selectedRoom = Enumerable.from(this.rooms).firstOrDefault(x => x.channel == "Channel" + this.streamBoxId)?.id;
        });


        this.streamBoxId = +params.get('id');

        this.titleService.setTitleAndLogPageView('StreamBox' + this.streamBoxId);

        this.model = new StreamBoxLayoutViewModel();
        //this.superSource16x9();
        this.model.cameraWidth = 640;
        this.model.cameraHeight = 480;
        this.model.cameraTop = 0;
        this.model.cameraLeft = 0;
        this.model.cameraOnAir = true;
        this.model.computerOnAir = false;

        of(null)
          .pipe(delay(5000))
          .subscribe((result) => {
            this.InitOpenTok();
          });

        this.cameraOnly();

        if (qParams.get('auto')) {
          of(null)
            .pipe(delay(10000))
            .subscribe((result) => {
              // this.shareBG();
              this.publishCamera();

            });
        }

        zE('webWidget', 'hide');
        this.InitSignalR();
      });
    });
  }

  InitSignalR(): any {
    this.connection = new HubConnectionBuilder()
      .withUrl('/streamBoxHub', {accessTokenFactory: () => this.auth.getToken()})
      .withAutomaticReconnect(new DefaultReconnectPolicy())
      .build();

    this.connection.start().then(() => {});

    this.connection.on('PanUp', (id) => {
      console.log('Pan up' + id);
    });

    this.initialized = true;
  }

  panUp() {
    this.connection.invoke('PanUp', this.streamBoxId);
  }

  panDown() {
    this.connection.invoke('PanDown', this.streamBoxId);
  }

  panLeft() {
    this.connection.invoke('PanLeft', this.streamBoxId);
  }

  panRight() {
    this.connection.invoke('PanRight', this.streamBoxId);
  }

  zoomIn() {
    this.connection.invoke('ZoomIn', this.streamBoxId);
  }

  zoomOut() {
    this.connection.invoke('ZoomOut', this.streamBoxId);
  }

  zoomStop() {
    this.connection.invoke('ZoomStop', this.streamBoxId);
  }

  panStop() {
    this.connection.invoke('PanStop', this.streamBoxId);
  }

  mute() {
    this.connection.invoke('mute', this.streamBoxId);
  }

  unmute() {
    this.connection.invoke('unmute', this.streamBoxId);
  }

  superSource16x9() {
    this.connection.invoke('Slides16x9', this.streamBoxId);
  }

  superSource4x3() {
    this.connection.invoke('Slides4x3', this.streamBoxId);
  }

  updateLayoutFromModel() {
    if (this.videoCanvas && this.videoCanvas.nativeElement) {
      var camera: HTMLElement = this.videoCanvas.nativeElement.querySelector('.OT_Camera');
      camera.style.setProperty('width', this.model.cameraWidth + 'px', 'important');
      camera.style.setProperty('height', this.model.cameraHeight + 'px', 'important');
      camera.style.setProperty('top', this.model.cameraTop + 'px', 'important');
      camera.style.setProperty('left', this.model.cameraLeft + 'px', 'important');
      camera.style.setProperty('display', this.model.cameraOnAir ? 'block' : 'none', 'important');

      var slides: HTMLElement = this.videoCanvas.nativeElement.querySelector('.OT_Screen');

      slides.style.setProperty('width', this.model.computerWidth + 'px', 'important');
      slides.style.setProperty('height', this.model.computerHeight + 'px', 'important');
      slides.style.setProperty('top', this.model.computerTop + 'px', 'important');
      slides.style.setProperty('left', this.model.computerLeft + 'px', 'important');
      slides.style.setProperty('display', this.model.computerOnAir ? 'block' : 'none', 'important');
    }
  }


  cameraOnly() {
    this.model.cameraWidth = 640;
    this.model.cameraHeight = 480;
    this.model.cameraTop = 0;
    this.model.cameraLeft = 0;
    this.model.cameraOnAir = true;
    this.model.computerOnAir = false;
    this.updateLayoutFromModel();
    //this.updateLayout();
  }

  // shareBG() {
  //   const canvas = <any>document.createElement('canvas');
  //   const canvasContext = canvas.getContext('2d');
  //   var img = this.background.nativeElement;

  //   let self = this;
  //   let draw = function () {
  //     canvasContext.drawImage(img, 0, 0, 1280, 720);
  //     setTimeout(draw, 1000);
  //   };

  //   draw();

  //   canvas.width = 1280;
  //   canvas.height = 720;

  //   const canvasStream = canvas.captureStream(5);
  //   const videoTracks = canvasStream.getVideoTracks();

  //   const el = this.renderer.createElement('div');

  //   var bgPublishd = OT.initPublisher(el, {
  //     name: 'BACKGROUND',
  //     videoSource: videoTracks[0],
  //     publishAudio: false,
  //     resolution: '1280x720',
  //     fitMode: 'contain',
  //     videoContentHint: 'text',
  //     frameRate: 1,
  //     width: 1280,
  //     height: 720,
  //   });

  //   this.renderer.appendChild(this.videoCanvas.nativeElement, el);

  //   this.session.publish(bgPublishd, (err) => {
  //     if (err) {
  //       alert(err.message);
  //     } else {
  //       //this.screenPublishing = true;
  //       this.ref.detectChanges();
  //     }
  //   });
  // }
  currentChannelStatus: WowzaChannelViewModel;

  stream() {
    this.streamBoxService.startStreaming(this.streamBoxId, this.model).subscribe((result) => {});
  }

  stopStream() {
    this.toasterService.confirmDialog('Are you sure you want to stop the stream?', 'Are you sure?').subscribe((result) => {
      if (result) {
        this.streamBoxService.stopStreaming(this.streamBoxId).subscribe((result) => {});
      }
    });
  }

  record() {
    this.streamBoxService.startRecording(this.streamBoxId).subscribe((result) => {});
  }

  stopRecord() {
    this.toasterService.confirmDialog('Are you sure you want to stop recording?', 'Are you sure?').subscribe((result) => {
      if (result) {
        this.streamBoxService.stopRecording(this.streamBoxId).subscribe((result) => {});
      }
    });
  }

  updateLayout() {
    this.streamBoxService.updateLayout(this.streamBoxId, this.model).subscribe((result) => {});
  }

  @HostListener('window:resize', ['$event'])
  resize(evt) {
    this.layout();
  }

  InitOpenTok() {
    this.ref.detectChanges();
    this.layout = initLayoutContainer(this.videoCanvas.nativeElement).layout;
    let layout = this.layout;
    let self = this;

    this.opentokService
      .initsessionForStreamBox(this.streamBoxId)
      .then((session: OT.Session) => {
        this.session = session;
        this.session.on('streamCreated', (event) => {
          console.log(event.stream.name);
          console.log(event.stream.connection.data);
          this.streamCount++;

          let subscription = this.session.subscribe(event.stream, 'videoCanvas', {
            insertMode: 'append',
            preferredResolution: {
              width: 1280,
              height: 720
            },
            style: {nameDisplayMode: 'off'},
          });

          if (event.stream.name == 'COMPUTER') {
            console.log('adding slides');
            subscription.element.classList.add('OT_BG');
          }

          if (event.stream.name == 'CAMERA') {
            console.log('adding camera');
            subscription.element.classList.add('OT_BG');
          }

          if (event.stream.name == 'BACKGROUND') {
            console.log('adding bg');
            subscription.element.classList.add('OT_BG');
          }

          subscription.element.addEventListener('dblclick', function () {
            if (subscription.element.classList.contains('OT_big')) {
              subscription.element.classList.remove('OT_big');
            } else {
              subscription.element.classList.add('OT_big');
            }
          });

          layout();
          this.ref.detectChanges();

          layout();

        });
        this.session.on('streamDestroyed', (event) => {
          this.streamCount--;
          session.getSubscribersForStream(event.stream).forEach((subscriber) => {
            subscriber.element.classList.remove('ot-layout');
          });
        });

      })
      .then(() => {
        this.opentokService.connect();

        self.setInitialized();
      })
      .catch((err) => {
        console.error(err);
        alert('Unable to connect. Make sure you have updated the config.ts file with your OpenTok details.');
      });
  }

  setInitialized() {
    console.log('connected');
    this.openTokInitialized = true;
  }

  publishCamera() {
    this.ref.detectChanges();

    const OT = this.opentokService.getOT();
    const el = this.renderer.createElement('div');

    if (this.selectedCameraDevice) {
      this.cameraPublisher = OT.initPublisher(el, {
        disableAudioProcessing: true,
        publishCaptions: true,
        mirror: false,
        fitMode: 'contain',
        publishAudio: true,
        publishVideo: true,
        resolution: '1920x1080',
        name: 'Streambox' + this.streamBoxId,
        width: '100%',
        insertDefaultUI: true,
        style: {
          nameDisplayMode: 'off',
          archiveStatusDisplayMode: 'auto',
          buttonDisplayMode: 'off'
        },
        audioSource: this.selectedCameraDevice.audioDeviceId,
        videoSource: this.selectedCameraDevice.videoDeviceId
      });
    } else {
      this.cameraPublisher = OT.initPublisher(el, {
        disableAudioProcessing: true,
        mirror: false,
        publishAudio: true,
        fitMode: 'contain',
        publishVideo: true,
        resolution: '1920x1080',
        name: 'Streambox' + this.streamBoxId,
        width: '100%',
        insertDefaultUI: true,
        style: {
          nameDisplayMode: 'off',
          archiveStatusDisplayMode: 'auto',
          buttonDisplayMode: 'off'
        }
      });
    }
    let layout = this.layout;

    //el.classList.add('OT_Camera');

    this.renderer.appendChild(this.videoCanvas.nativeElement, el);
    layout();
    this.cameraPublisher.on(
      'audioLevelUpdated',
      function (event) {
        if (this.movingAvg == null || this.movingAvg <= event.audioLevel) {
          this.movingAvg = event.audioLevel;
        } else {
          this.movingAvg = 0.7 * this.movingAvg + 0.3 * event.audioLevel;
        }

        // 1.5 scaling to map the -30 - 0 dBm range to [0,1]
        this.audioLevel = Math.log(this.movingAvg) / Math.LN10 / 1.5 + 1;
        this.audioLevel = Math.min(Math.max(this.audioLevel, 0), 1);
        this.soundBar.nativeElement.style.height = `${this.audioLevel * 100}%`;
      },
      this
    );

    this.session.publish(this.cameraPublisher, (err) => {
      if (err) {
        alert(err.message);
      } else {
        this.cameraPublishing = true;
        this.cameraOnly();
        this.layout();
        this.ref.detectChanges();
        this.layout();
        this.ref.detectChanges();
      }
    });
  }

  cameraDeviceSettings() {
    const modalRef = this.modalService.open(CameraTestModalComponent, {
      size: 'lg',
      backdrop: 'static',
      ariaLabelledBy: 'modal-basic-title'
    });
    if (this.selectedCameraDevice) {
      console.log(this.selectedCameraDevice);
      modalRef.componentInstance.selectedDevice = this.selectedCameraDevice;
    }
    modalRef.result.then(
      (result) => {
        this.selectedCameraDevice = result;
        localStorage.setItem('cameraDevice', JSON.stringify(this.selectedCameraDevice));

        if (this.cameraPublisher) {
          this.cameraPublisher.setVideoSource(this.selectedCameraDevice.videoDeviceId);
          this.cameraPublisher.setAudioSource(this.selectedCameraDevice.audioDeviceId);
        }
      },
      (reason) => {}
    );
    return;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.layout();
  }

  ngOnDestroy(): void {
    if (this.connection) {
      this.connection.stop();
    }

    if (this.cameraPublisher) {
      this.cameraPublisher.destroy();
    }

    if (this.screenPublisher) {
      this.screenPublisher.destroy();
    }

    if (this.session) {
      this.session.disconnect();
    }

    this.checker.unsubscribe();

  }

  public resetCameras() {
    localStorage.removeItem('cameraDevice');
    localStorage.removeItem('screenDevice');
  }


  public startChannel() {
    this.superUser.startChannel('Channel' + this.streamBoxId).subscribe(result => {this.getData()});

  }

  private getData() {
    this.superUser.getChannels().subscribe(data => {
      this.currentChannelStatus = data.find(x => x.name == 'Channel' + this.streamBoxId);
    });
  }

  WowzaState = WowzaState;
  WowzaStateEnum = Enums.WowzaStateEnum;
  StrWowzaStateEnum = StrWowzaStateEnum;

  public updateRoomForBox() {
    console.log('updating room' + this.selectedRoom);
    this.streamBoxService.updateChannelForStreambox(this.streamBoxId, this.selectedRoom).subscribe(result => {
      this.toasterService.success('Room updated');
    });
  }
}
